import { make } from "vuex-pathify"

const state = {
  webview: false,
  phraseMap: [],
  language: 'en',
  bottomSlot: null,
  dark: true,
  supportreq: false,
  fullScreen: false
};

const mutations = make.mutations(state);


export default {
  namespaced: true,
  state,
  mutations
}